import { getShopUid, isSiteDomain } from "../../settings/domainManager";

export function navigate_to_cart() {
  if (isSiteDomain) {
    return "/cart";
  }
  return `/${getShopUid()}/cart`;
}

export function navigate_to_cart_finalize() {
  if (isSiteDomain) {
    return "/order";
  }
  return `/${getShopUid()}/order`;
}

export function navigate_to_cart_invoice(cart_uid, payment) {
  if (isSiteDomain) {
    return `/factor/${cart_uid}?payment=${payment}`;
  }
  return `/${getShopUid()}/factor/${cart_uid}?payment=${payment}`;
}

export function navigate_to_shop_cart_invoice(shop_uid, cart_uid, payment) {
  if (isSiteDomain) {
    return `/factor/${cart_uid}?payment=${payment}`;
  }
  return `/${shop_uid}/factor/${cart_uid}?payment=${payment}`;
}
